'use client';

import { Flex, Box, Stack } from '@chakra-ui/react';
import { PropsWithChildren, useEffect, useState } from 'react';
import { ROUTES } from '@habity/constants';
import { LoanContactBanner } from '~/components/ui/banners/LoanContactBanner';
import { DesktopHeader } from './Header';
import { useUser } from '~/hooks/useUser';
import { usePathUtils } from '~/hooks/usePathUtils';
import { isBroker } from '~/lib/roles';
import { Footer } from '../footer/Footer';

const DesktopLayout = ({ children }: PropsWithChildren) => {
  const { user } = useUser();
  const { isExactPath, isNotExactPath, isNotPath } = usePathUtils();
  const [showLoanBanner, setShowLoanBanner] = useState<boolean>(true);

  const headerVisible =
    isNotPath(ROUTES.SELL) &&
    isNotExactPath(ROUTES.BUY) &&
    isNotPath(ROUTES.DASHBOARD.SPECULATOR.EDIT_PATH);

  const footerVisible =
    isNotPath(ROUTES.SELL) &&
    isNotExactPath(ROUTES.BUY) &&
    isNotPath(ROUTES.DASHBOARD.SPECULATOR.EDIT_PATH) &&
    isNotExactPath(ROUTES.CLIENT_PORTAL) &&
    isNotPath(ROUTES.ANALYTICS.INDEX);

  const isHeaderFullWidth = false;

  // FIXME: This is duplicated between desktop and mobile header
  const isHeaderWhite =
    isExactPath(ROUTES.ROOT) ||
    isExactPath(ROUTES.SEARCH.HOMES) ||
    isExactPath(ROUTES.SEARCH.SPECULATORS) ||
    isExactPath(ROUTES.SEARCH.BROKERS) ||
    isExactPath(ROUTES.SEARCH.AREAS) ||
    isExactPath(ROUTES.SEARCH.MUNICIPALITIES) ||
    isExactPath(ROUTES.SEARCH.PLACES) ||
    isExactPath(ROUTES.SEARCH.PROJECTS) ||
    isExactPath(ROUTES.DASHBOARD.BUYER.INDEX) ||
    isExactPath(ROUTES.DASHBOARD.ACCOUNT) ||
    isExactPath(ROUTES.CMS.HOW_IT_WORKS) ||
    isExactPath(ROUTES.CMS.FAQ);

  const Banners = () => {
    // Show loan contact banner if user is logged in, not a broker, and hasn't answered
    if (
      user &&
      !isBroker(user) &&
      showLoanBanner &&
      !(user as any).loan_contact_accepted_at &&
      !(user as any).loan_contact_denied_at
    ) {
      return <LoanContactBanner onAnswer={() => setShowLoanBanner(false)} />;
    }

    return null;
  };

  return (
    <Stack
      mx="-1px"
      p="0"
      flex="1"
      justifyContent="space-between"
      overflowX="hidden"
      overflowY="visible"
      minHeight="100vh"
      spacing="0"
    >
      <Stack flex="1" overflowY="visible" minH="0" spacing="0">
        {headerVisible && (
          <>
            <DesktopHeader
              containerMaxWidth={isHeaderFullWidth ? '100vw' : '1440px'}
              backgroundColor={isHeaderWhite ? 'white' : 'palePeach'}
            />
            {/* Header is fixed, so preserve its space */}
            <Box
              h="70px"
              backgroundColor={isHeaderWhite ? 'white' : 'palePeach'}
            />
          </>
        )}

        <Flex
          as="main"
          role="main"
          direction="column"
          flex="1"
          overflowY="visible"
          minH="0"
        >
          {children}
        </Flex>
      </Stack>

      {footerVisible && <Footer />}

      <Banners />
    </Stack>
  );
};

export default DesktopLayout;
